'use client'

import { IconDocumentPaperGray } from '@macarongfactory/web-icons'
import { Result, SolidButton } from '@macarongfactory/web-ui'

/** 빈 상태 아이콘 크기(px) — Figma 64×64 */
const EMPTY_ICON_SIZE_PX = 64

const EMPTY_TITLE = '랭킹이 없어요'
const EMPTY_DESCRIPTION = '연료 타입이나 차량 모델을 바꿔보세요'
const EMPTY_ACTION_TEXT = '전체 차량 보기'

interface IRankEmptyProps {
  /** '전체 차량 보기' 클릭 (전체 세그먼트로 이동 등) */
  onAction: () => void
}

/**
 * 랭킹 데이터 없음 상태 — Figma 8455:72440
 * (선택한 유종/차급 조합에 데이터가 없을 때)
 */
const RankEmpty = ({ onAction }: IRankEmptyProps) => (
  <div className='flex min-h-[360px] w-full flex-col items-center justify-center bg-background-surface-default lg:rounded-dimension-x4'>
    <Result
      top={
        <Result.Top.Image>
          <IconDocumentPaperGray
            width={EMPTY_ICON_SIZE_PX}
            height={EMPTY_ICON_SIZE_PX}
          />
        </Result.Top.Image>
      }
      title={<Result.Title text={EMPTY_TITLE} />}
      description={<Result.Description text={EMPTY_DESCRIPTION} />}
      button={
        <SolidButton
          variant='neutral-weak'
          text={EMPTY_ACTION_TEXT}
          size='medium'
          clickable={onAction}
        />
      }
    />
  </div>
)

export default RankEmpty
